import NodeHandler from "./node_handler";

function scrollToTargetAdjusted(element, offsetTop = 0){
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offsetTop;
    window.scrollTo({
         top: offsetPosition,
         behavior: "smooth"
    });
}

function compare_as_number(a, b){
    a = Number(a)
    b = Number(b)
    return a - b
}

function getDocumentHeight(){
    const body = document.body,
        html = document.documentElement;
    return Math.max( body.scrollHeight, body.offsetHeight, 
        html.clientHeight, html.scrollHeight, html.offsetHeight );
}

class ScrollAnchor extends NodeHandler{
    __init_dom_schema(){
        return {
            __node__: {
                actions: {
                    'click': this.scrollTo.bind(this),
                }
            },
        }
    }

    __init(){
        this.id = this.node.getAttribute('data-id');
        this.dom.target = document.getElementById(this.id)

        this.registerEvents('toggle')
    }

    getRect(){
        const rect = this.dom.target.getBoundingClientRect()
        return rect
    }

    getId(){
        return this.id
    }

    toggle(bool = null){
        this.node.classList.toggle('is--active', bool)

        this.dispatchEvent('toggle', {
            value: bool,
            sender: this
        })
    }

    scrollTo(){
        scrollToTargetAdjusted(
            this.dom.target,
            ScrollAnchorsHandler.getInstance().offset - 20
        )
    }
}

class ScrollAnchorsHandler{
    static instance;
    static getInstance(...args){
        if(! this.instance){
            this.initInstance(...args)
        }
        return this.instance
    }
    static initInstance(...args){
        this.instance = new this(...args)
    }
    constructor(config){
        this.offset_callback = config?.offset_callback
        this.offset = 0
        this.anchors = []
        this.anchors_map = new Map()
        this.initActions()
    }
    initActions(){
        window.addEventListener('scroll', this.handleScrollEvent.bind(this))
        window.addEventListener('resize', this.handleResizeEvent.bind(this))
    }
    handleScrollEvent(event){
        this.handleScroll()
    }
    handleScroll(){
        const keys = this.ordered_anchors.keys().toArray()
        for(let i = 0; i < keys.length-1; i++){
            const anchor = this.ordered_anchors.get(keys[i])
            anchor.toggle(false)
            
            if(
                window.scrollY > Number(keys[i]) 
                && window.scrollY < Number(keys[i+1])
            ){
                anchor.toggle(true)
            }
        }
    }
    handleResizeEvent(event){
        this.build()
    }
    scrollById(id){
        const anchor = this.anchors_map.get(id)
        if(anchor){
            anchor.scrollTo()
        }
    }
    findAnchorById(id){        
        return this.anchors_map.get(id)
    }
    append(dom_anchors){
        for(const dom_anchor of dom_anchors){
            this.anchors.push(
                new ScrollAnchor(dom_anchor)
            )
        }
        this.build()
    }
    build(){
        if(this.offset_callback){
            this.offset = this.offset_callback()
        }else{
            this.offset = 0
        }

        let position_dict = {}
        for(const anchor of this.anchors){
            const rect = anchor.getRect()
            let position = rect.top + window.scrollY - this.offset
            position_dict[position] = anchor
            this.anchors_map.set(anchor.getId(), anchor)
        }       
        position_dict[getDocumentHeight()] = {}

        this.ordered_anchors = new Map()
        Object.keys(position_dict).sort(compare_as_number).reduce(
          (obj, key) => { 
            this.ordered_anchors.set(key, position_dict[key])
          }, 
          {}
        );
    }
}

export {
    ScrollAnchorsHandler
}